<template>
    <div>
        <div class="miku__header">
            <div class="customer-service-header ">
                <div class="row">
                    <div class="col-12 p-xl-0 p-sm-2 small">
                        <i class="fas fa-phone"></i>
                        <a href="tel:+66632970492">063-297-0492</a>,
                        <a href="tel:+66621966190">062-196-6190</a>      
                        <a href="https://lin.ee/2oiTubz"><img src="/static/img/floatingButton/line.png" data-platform="line" class="img-fluid" width="18">@mikuagency</a>
                    </div>
                </div>
            </div>
            <nav class="navbar navbar-expand-lg navbar-light bg-light shadow-sm bg-white" >
                <div class="container p-0">
                    <router-link to="/" tag="a" class="navbar-brand">
                        <img src="/static/img/recruitment/MIKU-AGENCY-LOGO.png"
                            :style="$mq.phone ? 'padding: 0 1rem' : ''"
                            height="50"
                            alt="">
                    </router-link>
                </div>
            </nav>
        </div>
        <section class="container">
            
            <!-- Banner -->
            <section class="py-1" id="header-maid-banner">
                <b-img :src="'https://beneat.s3.ap-southeast-1.amazonaws.com/recruitment/maid_banner_1.png'" fluid alt="..."></b-img>    
            </section>
            <!-- Form Input -->
            <section >
                <div class="row no-gutters">
                    <div class="col-12 col-md-6 col-lg-6 p-2 " id="form-maid-recruitment">
                        <div class="card m-0">
                            <div class="text-center my-2">
                                <p class="h4 font-weight-bolder">คำขอรับบริการ</p>
                                <p class="h4 font-weight-bolder">บริการจัดหาแม่บ้าน ผู้ช่วยประจำบ้าน</p>
                            </div>
                            <div class="d-flex justify-content-between">
                                <p class="font-weight-bolder p-3">ข้อมูลการติดต่อ</p> 
                                <a href="#" v-scroll-to="{el:'#what-a-service', offset: $mq.phone ? -110 : -230}">
                                    <button class="btn btn-sm btn-outline-info mx-1">
                                        รายละเอียดบริการจัดหา
                                    </button>
                                </a>
                            </div>
                            <div class="px-3">
                                <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" >
                                    <b-form-group id="input-group-name">
                                        <label for="input-1">ชื่อผู้ติดต่อ <span class="text-danger">*</span></label>
                                        <b-form-input
                                            type="text"    
                                            id="input-1"
                                            v-model="formMaidRecruitment.name"
                                            placeholder=""
                                            required
                                        ></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="input-group-tel">
                                        <label for="input-3">เบอร์โทร <span class="text-danger">*</span></label>
                                        <b-form-input
                                            type="tel"
                                            id="input-3"
                                            v-model="formMaidRecruitment.tel"
                                            placeholder=""
                                            required
                                        ></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="input-group-salary">

                                        <label for="input-2">ช่วงเงินเดือน <span class="text-danger">*</span></label>
                                        <b-form-select v-model="optionSalary" class="mb-3" required>
                                            <template #first>
                                                <b-form-select-option :value="null" disabled>กรุณาเลือกช่วงเงินเดือน</b-form-select-option>
                                            </template>
                                            <b-form-select-option v-for="(item, index) in ['13,000-15,000','15,000-18,000','18,000-20,000']" :key="index" :value="index" >{{ item }}</b-form-select-option>
                                        </b-form-select>
                                        
                                    </b-form-group>
                                    <b-form-group v-slot="{ ariaDescribedby }">
                                        <label>ประเภทบริการที่ต้องการ <span class="text-danger">*</span></label>
                                        <div class="row no-gutters">
                                            <div class="col-12 col-md-6 col-lg-6 ">
                                                <b-form-radio 
                                                    class="mt-2"
                                                    v-model="formMaidRecruitment.service_required" 
                                                    :aria-describedby="ariaDescribedby" 
                                                    name="service-radios" 
                                                    value="คุณแม่บ้าน ทําความสะอาด" 
                                                    required
                                                >
                                                    คุณแม่บ้าน ทําความสะอาด
                                                </b-form-radio>
                                                <b-form-radio 
                                                    class="mt-2"
                                                    v-model="formMaidRecruitment.service_required" 
                                                    :aria-describedby="ariaDescribedby" 
                                                    name="service-radios" 
                                                    value="คุณแม่บ้าน กึ่งแม่ครัว" 
                                                    required
                                                >
                                                    คุณแม่บ้าน กึ่งแม่ครัว
                                                </b-form-radio>
                                                <b-form-radio 
                                                    class="mt-2"
                                                    v-model="formMaidRecruitment.service_required" 
                                                    :aria-describedby="ariaDescribedby" 
                                                    name="service-radios" 
                                                    value="คุณแม่บ้าน กึ่งพี่เลี้ยงเด็ก" 
                                                    required
                                                >
                                                    คุณแม่บ้าน กึ่งพี่เลี้ยงเด็ก
                                                </b-form-radio>
                                                <b-form-radio 
                                                    class="mt-2"
                                                    v-model="formMaidRecruitment.service_required" 
                                                    :aria-describedby="ariaDescribedby" 
                                                    name="service-radios" 
                                                    value="คุณแม่บ้าน กึ่งดูแลผู้สูงอายุ" 
                                                    required
                                                >
                                                    คุณแม่บ้าน กึ่งดูแลผู้สูงอายุ
                                                </b-form-radio>
                                                <b-form-radio 
                                                    class="mt-2"
                                                    v-model="formMaidRecruitment.service_required" 
                                                    :aria-describedby="ariaDescribedby" 
                                                    name="service-radios" 
                                                    value="คุณแม่บ้าน กึ่งดูแลผู้ป่วย" 
                                                    required
                                                >
                                                    คุณแม่บ้าน กึ่งดูแลผู้ป่วย
                                                </b-form-radio>
                                            </div>
                                            <div class="col-12 col-md-6 col-lg-6 ">
                                                <b-form-radio 
                                                    class="mt-2"
                                                    v-model="formMaidRecruitment.service_required" 
                                                    :aria-describedby="ariaDescribedby" 
                                                    name="service-radios" 
                                                    value="คุณแม่บ้าน กึ่งดูแลสัตว์เลี้ยง" 
                                                    required
                                                >
                                                    คุณแม่บ้าน กึ่งดูแลสัตว์เลี้ยง
                                                </b-form-radio>
                                                <b-form-radio 
                                                    class="mt-2"
                                                    v-model="formMaidRecruitment.service_required" 
                                                    :aria-describedby="ariaDescribedby" 
                                                    name="service-radios" 
                                                    value="พี่เลี้ยงเด็ก" 
                                                    required
                                                >
                                                    พี่เลี้ยงเด็ก
                                                </b-form-radio>
                                                <b-form-radio 
                                                    class="mt-2"    
                                                    v-model="formMaidRecruitment.service_required" 
                                                    :aria-describedby="ariaDescribedby" 
                                                    name="service-radios" 
                                                    value="พนักงานดูแลผู้สูงอายุ" 
                                                    required
                                                >
                                                    พนักงานดูแลผู้สูงอายุ
                                                </b-form-radio>
                                                <b-form-radio 
                                                    class="mt-2"
                                                    v-model="formMaidRecruitment.service_required" 
                                                    :aria-describedby="ariaDescribedby" 
                                                    name="service-radios" 
                                                    value="พนักงานดูแลผู้ป่วย/ผู้ป่วยติดเตียง" 
                                                    required
                                                >
                                                    พนักงานดูแลผู้ป่วย/ผู้ป่วยติดเตียง
                                                </b-form-radio>
                                                <b-form-radio 
                                                    class="mt-2"
                                                    v-model="formMaidRecruitment.service_required" 
                                                    :aria-describedby="ariaDescribedby" 
                                                    name="service-radios" 
                                                    value="งานคู่ สามี-ภรรยา" 
                                                    required
                                                >
                                                    งานคู่ สามี-ภรรยา
                                                </b-form-radio>
                                            </div>
                                        </div>
                                    </b-form-group>
                                    <b-form-group id="input-group-province" >
                                        <label for="input-4">จังหวัด <span class="text-danger">*</span></label> 
                                        <b-form-select v-model="formMaidRecruitment.province" class="mb-3" required>
                                            <template #first>
                                            <b-form-select-option :value="null" disabled>กรุณาเลือกจังหวัดที่ใช้บริการ</b-form-select-option>
                                            </template>
                                            <b-form-select-option v-for="(item, index) in provinces" :key="index" :value="item.id" >{{ item.name_th }}</b-form-select-option>
                                        </b-form-select>
                                    </b-form-group>
                                    <div>
                                        <p class="m-0 text-warning">เงื่อนไขการให้บริการ</p>
                                        <p class="m-0">บริการจัดหาคุณแม่บ้าน Miku จะเป็นเป็นตัวกลางในการจัดหาคุณแม่บ้านตามรายละเอียดและเงื่อนไขที่
                                            คุณลูกค้าแจ้งมา โดยคุณแม่บ้านจะเป็นพนักงานหรือเป็นลูกจ้างประจำ
                                            ของคุณลูกค้าโดยที่คุณลูกค้าสามารถตกลง สวัสดิการ เงินเดือน รายได้พิเศษ ฯลฯ
                                            กับคุณแม่บ้านผู้สมัครได้โดยตรง</p>
                                    </div>
                                    <div class="text-center">
                                        
                                        <b-button type="submit" class="btn btn-info my-1" :class="$mq.phone ? 'btn-block': 'btn-sm'" >ส่งคำขอรับบริการจัดหา</b-button>
        
                                        <!-- <b-button type="submit" class="btn btn-info my-1" :class="$mq.phone ? 'btn-block': 'btn-sm'" >
                                            ส่งคำขอรับบริการจัดหา
                                        </b-button> -->
                                        <a href="https://lin.ee/2oiTubz" target="_blank" id="blinking-text">
                                            <p style="font-size: 12px">สอบถามรายละเอียดเพิ่มเติม<b-img src="/static/img/recruitment/line_contact.png" width="70" alt="..."></b-img>
                                            </p>
                                        </a>
                                    </div>
                                </b-form>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-6 p-2 ">
                        <b-img src="/static/img/recruitment/maid_service.png" fluid alt="..."></b-img>
                        <div class="text-center my-2">
                            <h3>ติดต่อเรา</h3>
                            <b-img src="/static/img/recruitment/qr_recruitment.png" fluid alt="..."></b-img>
                            <h3 class="text-info"> <a href="tel:063-297-0492">063-297-0492</a>  หรือ <a href="tel:062-196-6190">062-196-6190</a></h3>
                            <div class="mb-1">
                                <a href="https://lin.ee/2oiTubz">
                                    <button type="button" class="btn btn-success">
                                        LINE ID : @mikuagency
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
            <div class="p-1" id="what-a-service">
                <!-- What a service -->
                <section class="card">
                    <!-- <div class="text-center pt-3">
                        <h3>บริการจัดหาคุณแม่บ้านประจำ ทำอะไรบ้าง?</h3>
                    </div>
                    <hr> -->
                    <div class="row no-gutters">
                        <div class="col-12 col-md-6 col-lg-6 pl-4 pt-4">
                            <div :class="$mq.phone ? 'text-center' : ''">
                                <h2 class="text-info">
                                    Our Vision
                                </h2>
                                <p class="text-info">
                                    "เป็นหนึ่งด้านการหาผู้ช่วยที่มีคุณภาพด้วยบริการที่เป็นมาตรฐาน"
                                </p>
                            </div>
                            <div class="mr-3">
                                <div class="d-flex">
                                    <div class="number__circle font-weight-bolder">1</div>
                                    <span class="font-weight-bolder text__middle pl-2">สรรหาตามคุณสมบัติด้วยความรวดเร็ว</span>
                                </div>
                                <p class="text__left pl-2">ทำหน้าที่สรรหาผู้ช่วยให้ตรงตามคุณสมบัติที่คุณลูกค้ากำหนด ด้วยความรวดเร็ว</p>
                            </div>
                            <div class="mr-2">
                                <div class="d-flex">
                                    <span class="number__circle font-weight-bolder">2</span>
                                    <span class="font-weight-bolder text__middle pl-2">เตรียมความพร้อมก่อนเริ่มงาน</span>
                                </div>
                                <p class="text__left pl-2">ตรวจสอบประวัติอาชญากรรม และตรวจสุขภาพตามความประสงค์ของคุณลูกค้า</p>
                            </div>
                            <div class="mr-2">
                                <div class="d-flex">
                                    <span class="number__circle font-weight-bolder">3</span>
                                    <span class="font-weight-bolder text__middle pl-2">การันตีคุณภาพ</span>
                                </div>
                                <p class="text__left pl-2">รับประกันความพึงพอใจ สามารถเปลี่ยนผู้ช่วยได้</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-6 p-2">
                            <b-img :src=" $mq.phone ? '/static/img/recruitment/maid_ph1_mq.png' : '/static/img/recruitment/maid_ph1.png'" fluid alt="..."></b-img>
                        </div>
                    </div>
                </section>
                <!-- Service description -->
                <section class="card pb-3">
                    <div class="text-center pt-3">
                        <h3>ระบุคุณสมบัติคุณแม่บ้านที่ต้องการได้</h3>
                    </div>
                    <hr>
                    <div class="row no-gutters">
                        <div class="col-12 col-md-6 col-lg-6 p-2">
                            <b-img :src=" $mq.phone ? '/static/img/recruitment/maid_ph2_mq.png' : '/static/img/recruitment/maid_ph2.png'" fluid alt="..."></b-img>
                        </div>
                        <div class="col-12 col-md-6 col-lg-6 pl-2">
                            <div class="mt-2 ml-2">
                                <div class="d-flex">
                                    <i class="fa fa-check-square fa-1x padding__icon text-success" aria-hidden="true"></i>
                                    <span class="ml-1 font-weight-bolder text__middle">ประเภท : (บ้าน/คอนโด/สำนักงาน/โรงแรม)</span>
                                </div>
                            </div>
                            <div class="mt-2 ml-2">
                                <div class="d-flex">
                                    <i class="fa fa-check-square fa-1x padding__icon text-success" aria-hidden="true"></i>
                                    <span class="ml-1 font-weight-bolder text__middle">วันเวลาที่ปฏิบัติงาน / พักอาศัย / ไป-กลับ</span>
                                </div>
                            </div>
                            <div class="mt-2 ml-2">
                                <div class="d-flex">
                                    <i class="fa fa-check-square fa-1x padding__icon text-success" aria-hidden="true"></i>
                                    <span class="ml-1 font-weight-bolder text__middle">เงินเดือน สวัสดิการอื่นๆ และ วันหยุด</span>
                                </div>
                            </div>
                            <div class="mt-2 ml-2">
                                <div class="d-flex">
                                    <i class="fa fa-check-square fa-1x padding__icon text-success" aria-hidden="true"></i>
                                    <span class="ml-1 font-weight-bolder text__middle">จังหวัด/เขต/แขวง</span>
                                </div>
                            </div>
                            <div class="mt-2 ml-2">
                                <div class="d-flex">
                                    <i class="fa fa-check-square fa-1x padding__icon text-success" aria-hidden="true"></i>
                                    <span class="ml-1 font-weight-bolder text__middle">รายละเอียดเกี่ยวกับงานที่ต้องทำ</span>
                                </div>
                            </div>
                            <div class="mt-2 ml-2">
                                <div class="d-flex">
                                    <i class="fa fa-check-square fa-1x padding__icon text-success" aria-hidden="true"></i>
                                    <span class="ml-1 font-weight-bolder text__middle">รายละเอียดงานอื่นๆ ที่ต้องการ เช่น ทำอาหาร, รีดผ้า, ซักผ้า, รักสัตว์, พี่เลี้ยงเด็ก, ดูแลผู้สูงอายุ ฯลฯ</span>
                                </div>
                            </div>
                            <div class="mt-3 ml-2">
                                <p>
                                    หลังจากการประกาศหาคุณแม่บ้านในระบบที่รับเงื่อนไข
                                    และรายละเอียดงานของคุณลูกค้าได้ ฝ่ายจัดหาจะจัดส่งโปรไฟล์
                                    คุณแม่บ้านที่สมัครและสนใจงานประจำของคุณลูกค้าให้ได้เลือก และนัดสัมภาษณ์งานต่อไป
                                    <a href="#" v-scroll-to="{el:'#form-maid-recruitment', offset: $mq.phone ? -110 : -130}" v-if="!$mq.phone">
                                        <button type="button" class="btn btn-sm btn-info">
                                            ส่งคำขอรับบริการจัดหา
                                        </button>
                                    </a>
                                </p>
                                <div class="text-center" v-if="$mq.phone">
                                    <a href="#"  v-scroll-to="{el:'#form-maid-recruitment', offset: $mq.phone ? -110 : -130}">
                                        <button type="button" class="btn btn-sm btn-info">
                                            ส่งคำขอรับบริการจัดหา
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <!-- QR contact us -->
                <section>
                    <div class="text-center my-2">
                        <!-- <h2>ติดต่อเรา</h2>
                        <b-img src="/static/img/recruitment/qr_recruitment.png" fluid alt="..."></b-img>
                        <h3 class="text-info">063-297-0492 หรือ 062-196-6190</h3>
                        <div class="mb-1">
                            <a href="https://lin.ee/2oiTubz">
                                <button type="button" class="btn btn-success">
                                    LINE ID : @beneatmanpower
                                </button>
                            </a>
                        </div> -->
                        <a href="#"  v-scroll-to="{el:'#form-maid-recruitment', offset: $mq.phone ? -110 : -130}" class="text-center mb-2">
                            <button type="button" class="btn btn-info mt-3" style="border-radius: 25px;">
                            <i class="fa fa-chevron-up fa-2x"></i>
                            </button>
                            <br>
                            <span style="color:#32a2b8 ">BACK TO TOP</span>
                        </a>
                    </div>
                </section>
            </div>
            <sweet-modal ref="modalRequestDetail" :width="!$mq.phone? '80%':''">
                <div class="text-center">
                    <b-img src="/static/img/recruitment/logo_BM.png" width="300" alt="..."></b-img>
                </div>
                <div class="text-center">
                    <h2 class="text-info">
                        รหัสคำขอบริการจัดหา REF ID : {{ jobPost ? jobPost.ref_id : '' }}
                        <button v-if="jobPost && jobPost.ref_id"
                            class="h5 btn btn-outline-secondary"
                            type="button"
                            v-clipboard:copy="jobPost.ref_id" style="cursor: pointer;">
                        <i class="fa fa-clone mb-1">คัดลอก</i>
                    </button>
                    </h2>
                    <p>ขอขอบคุณที่สนใจใช้บริการจัดหาคุณแม่บ้านประจำ BeNeat</p>
                    <p>ทางเจ้าหน้าที่จะติดต่อกลับท่าน ภายใน 24 ชั่วโมง</p>
                    <p>หรือถ้าหากต้องการสอบถามเพิ่มเติมสามารถแจ้งรหัสคำขอบริการจัดหาได้ที่ Line Official ได้เลยค่ะ</p>
                    <div>
                        <a href="https://lin.ee/2oiTubz">
                            <button class="btn rounded-pill" style="background-color: #39cd02;">
                                <div class="d-flex">
                                    <img src="/static/img/floatingButton/line.png" data-platform="line" class="img-fluid rounded-circle" width="48">
                                    <div class="text-white">
                                    <span class="font-weight-bolder h3">Click !!! </span> <br> กดเพื่อแอดไลน์
                                    </div>
                                </div>
                            </button>
                        </a>
                    </div>
                </div>

                <!-- contact -->
            
                <div class="mt-3" style="background-color: #3ce5ffba;">
                    Contact : 063-297-0492 หรือ 062-196-6190 | เวลาทำการวันจันทร์ - วันเสาร์  |  เวลา 08.30 - 17.30 น.
                </div>
            </sweet-modal>
        </section>
      
        <footer class="footer-section">
            <div class="row">
                <div class="col-md-4">
                    <h2>ลูกค้า</h2>
                    <p>รายละเอียดจัดหา <br>ประเภทการให้บริการ <br>เงื่อนไขการให้บริการ <br> การระบุคุณสมบัติคุณแม่บ้าน</p>
                    <a href="#"  v-scroll-to="{el:'#form-maid-recruitment', offset: $mq.phone ? -110 : -130}">
                        <button type="button" class="btn btn-sm btn-info">
                            ส่งคำขอรับบริการจัดหา
                        </button>
                    </a>
                </div>
                <div class="col-md-4">
                    <h2>{{ $t('message.footer.contact_us') }}</h2>
                    <ul class="list-unstyled footer-list">
                      <li>
                        <i class="fas fa-map-marker-alt"></i>&nbsp;
                        <span v-html="$t('message.footer.address.04')"></span>
                      </li>
                    </ul>
                    <div class="p-xl-0 p-sm-2 ">
                        <i class="fas fa-phone"></i>
                        <a href="tel:+66632970492">063-297-0492</a>,
                        <a href="tel:+66621966190">062-196-6190</a>      
                    </div>
                    <div class="pt-2">
                        <a href="https://www.messenger.com/t/beneatco/" target="_blank">
                            <img height="38" alt="FB Messenger BeNeat" src="/static/img/btn-fb-messenger.png">
                            </a>
                        <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">
                            <img height="38" alt="Line BeNeat" src="/static/img/btn-line.png">
                            </a>
                        
                    </div>
                </div>
                <div class="col-md-4 miku__footer">
                    <h2>ผู้สนใจสมัครงาน</h2>
                    <p>สนใจทักไลน์ไอดี : @jobmaid ( มี @ ข้างหน้าด้วยนะคะ )</p>
                    <div class="text-center">
                        <div class="p-xl-0 p-sm-2">
                            <i class="fas fa-phone"></i>
                            <a href="tel:+66632970492">063-297-0492</a>,
                            <a href="tel:+66621966190">062-196-6190</a>      
                        </div>
                   
                        <b-img src="/static/img/recruitment/qr_recruitment.png" fluid alt="..." width="100" ></b-img>
                        <div class="mb-1 blink" >
                            <a href="https://lin.ee/2oiTubz">
                                <button type="button" class="btn btn-success">
                                    LINE ID : @mikuagency
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    Copyright © 2024 by BeNeat Co.,Ltd. All right reserved.
                </div>
                </div>
        </footer>
    
    </div>
</template>
<script>
import axios from 'axios'
import { SweetModal } from 'sweet-modal-vue'
export default {
  components: {
    SweetModal
  },
  data: () => ({
    formMaidRecruitment: {
      name: null,
      tel: null,
      service_required: null,
      province: null,
      min_salary: null,
      max_salary: null
    },
    provinces: null,
    jobPost: null,
    optionSalary: null
  }),
  watch: {
    optionSalary (n, o) {
      const salaryRanges = {
        0: { min: 13000, max: 15000 },
        1: { min: 15000, max: 18000 },
        2: { min: 18000, max: 20000 }
      }
      const selectedRange = salaryRanges[n]
      if (selectedRange) {
        this.formMaidRecruitment.min_salary = selectedRange.min
        this.formMaidRecruitment.max_salary = selectedRange.max
      }
    }
  },
  methods: {
    onSubmit () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$swal({
            type: 'success',
            title: 'ส่งข้อมูลสำเร็จ',
            allowOutsideClick: false
          }).then((result) => {
            if (result) {
              // save to db
              this.save()
              // this.$refs.modalRequestDetail.open()
            }
          })
        }
      })
    },
    async save () {
      const { data } = await axios.post('job-posts', this.formMaidRecruitment)
      if (!data.error) {
        this.jobPost = data.job_post
        this.$refs.modalRequestDetail.open()
      } else {
        this.$swal('Error', 'ส่งข้อมูลไม่สำเร็จกรุณาติดต่อแอดเพื่อสอบถามเพิ่มเติม', 'error')
      }
      this.onReset()
    },
    onReset () {
      this.optionSalary = null
      this.formMaidRecruitment.name = null
      this.formMaidRecruitment.min_salary = null
      this.formMaidRecruitment.max_salary = null
      this.formMaidRecruitment.tel = null
      this.formMaidRecruitment.service_required = null
      this.formMaidRecruitment.province = null
    },
    copiedCode (code) {
      this.$swal({
        title: code,
        text: 'คัดลอกรหัสสำเร็จ',
        type: 'success',
        timer: 800,
        showConfirmButton: false
      })
    },
    async fetchProvinceDistrict () {
      const { data } = await axios.get('address-provinces', {params: {is_all: true}})
      if (!data.error) {
        this.provinces = data.address_provinces
      }
    }
  },
  created () {
    this.fetchProvinceDistrict()
  }
}
</script>
<style scoped>
.number__circle {
    border-radius: 50%;
    width: 36px;
    height: 36px;
    padding: 5px;

    background: #17a2b8ba;
    border: 2px solid #fff;
    color: #fff;
    text-align: center;
}
.text__left {
    margin-left: 36px;
}
.text__middle {
    align-content: center;
}
.checked__box {
    border-radius: 25%;
    width: 36px;
    height: 36px;
    padding: 5px;

    background: #1cb817;
    border: 2px solid rgba(0, 0, 0, 0.41);
    color: #fff;
    text-align: center;
}
.padding__icon {
    padding-top: 5px;
}


#blinking-text, .blink {
    animation: blink 1.25s linear infinite;
  }
  
@keyframes blink {
    0%, 100% {opacity: 1;}
    50% {opacity: 0;}
  }

.miku__header {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1030;
}
.miku__footer {
    border-left: 2px solid white;
}

  
</style>


// WEBPACK FOOTER //
// src/components/recruitment/Index.vue